import React from "react";
import { ATV_STATUS_LIST, BUTTON_CHANGE_STATUS } from "./Constants";
import { useApp } from "contexts/BookingContext";
// import { Edit, RefreshCw, Trash2, X } from "lucide-react";

const Modal = ({ isOpen, onClose, bookingData, selectedSession }) => {
  const { sessions, setSessions, setIsOpenCanvas, setSelectedBooking } =
    useApp();

  if (!isOpen) return null;

  const handleUpdate = (id) => {
    onClose();
    setIsOpenCanvas(true);
    setSelectedBooking({
      ...bookingData,
      type: "edit",
      sessions: selectedSession,
    });
  };

  const handleChangeStatus = (id) => {
    onClose();
    setIsOpenCanvas(true);
    setSelectedBooking({
      ...bookingData,
      type: "change_status",
      sessions: selectedSession,
    });
  };

  const handleRemove = (id) => {
    setSessions((prev) => {
      const newSessions = [...prev];
      const sessionIndex = newSessions.findIndex(
        (session) => session.id.toString() === selectedSession.id.toString()
      );

      newSessions[sessionIndex].bookings = newSessions[
        sessionIndex
      ].bookings.filter((booking) => booking.id !== id);

      return newSessions;
    });

    onClose();
  };

  return (
    <>
      <div className="fixed inset-0 flex justify-center items-center z-50 bg-black bg-opacity-30">
        <div className="bg-white rounded-lg shadow-lg w-full max-w-2xl mx-4">
          {/* Header Modal */}
          <div className="p-6 border-b border-gray-200">
            <h2 className="text-2xl font-semibold text-gray-800 mb-2">
              Booking Details
            </h2>
          </div>

          {/* Body Modal */}
          <div className="p-6 space-y-3">
            {/* Booking Information */}
            <div className="bg-gray-50 p-6 rounded-lg shadow-md">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4 text-gray-700">
                <div className="grid grid-cols-[100px_auto] gap-2">
                  <span className="font-semibold">ID</span>
                  <span>: {bookingData.id}</span>
                </div>
                <div className="grid grid-cols-[100px_auto] gap-2">
                  <span className="font-semibold">Name</span>
                  <span>: {bookingData.name}</span>
                </div>
                <div className="grid grid-cols-[100px_auto] gap-2">
                  <span className="font-semibold">Agent</span>
                  <span>: {bookingData.agent}</span>
                </div>
                <div className="grid grid-cols-[100px_auto] gap-2">
                  <span className="font-semibold">Bike</span>
                  <span>: {bookingData.bike}</span>
                </div>
                <div className="grid grid-cols-[100px_auto] gap-2">
                  <span className="font-semibold">Guest</span>
                  <span>: {bookingData.guest}</span>
                </div>
                <div className="grid grid-cols-[100px_auto] gap-2 items-center">
                  <span className="font-semibold">Status</span>
                  <span
                    className={`px-2 py-1 rounded-full text-sm w-full font-semibold ${
                      bookingData.status.name === "Arrived"
                        ? "bg-blue-100 text-blue-700"
                        : bookingData.status.name === "Cancelled"
                        ? "bg-orange-100 text-orange-700"
                        : bookingData.status.name === "Completed"
                        ? "bg-green-100 text-green-700"
                        : "bg-red-100 text-red-700"
                    }`}
                  >
                    {bookingData.status.name}
                  </span>
                </div>
                {/* sesi */}
                <div className="grid grid-cols-[100px_auto] gap-2">
                  <span className="font-semibold">Session</span>
                  <span>
                    : {bookingData.session ? bookingData.session : "Sesi 1"}
                  </span>
                </div>
              </div>
            </div>

            {/* Product Table */}
            <div className="mt-4 overflow-auto max-h-60">
              <table className="min-w-full border border-gray-300 bg-white shadow-sm rounded-lg">
                <thead>
                  <tr className="bg-gray-100 text-gray-700">
                    <th className="px-6 py-3 border-b text-left font-semibold">
                      Name
                    </th>
                    <th className="px-6 py-3 border-b text-left font-semibold">
                      Price
                    </th>
                    <th className="px-6 py-3 border-b text-left font-semibold">
                      Quantity
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {bookingData.product.map((product, index) => (
                    <tr
                      key={index}
                      className={`text-gray-700 ${
                        index % 2 === 0 ? "bg-white" : "bg-gray-50"
                      }`}
                    >
                      <td className="px-6 py-2 border-b">{product.name}</td>
                      <td className="px-6 py-2 border-b">{product.price}</td>
                      <td className="px-6 py-2 border-b">{product.qty}</td>
                    </tr>
                  ))}
                  <tr className="bg-gray-100 font-semibold text-gray-800">
                    <td colSpan="2" className="px-6 py-3 border-b text-right">
                      Total Reducer:
                    </td>
                    <td className="px-6 py-3 border-b text-center">5</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Footer Modal - Action Buttons */}
          <div className="p-4 bg-gray-100 flex justify-end gap-2 border-t border-gray-200">
            <button
              className="flex items-center gap-2 py-2 px-4 bg-red-500 text-white rounded-md hover:bg-red-600"
              onClick={(e) => {
                e.preventDefault();
                handleRemove(bookingData.id);
              }}
            >
              {/* <Trash2 className="w-4 h-4" /> */}
              Remove
            </button>
            <button
              className="flex items-center gap-2 py-2 px-4 bg-orange-500 text-white rounded-md hover:bg-orange-600"
              onClick={(e) => {
                e.preventDefault();
                handleChangeStatus(bookingData.id);
              }}
            >
              {/* <RefreshCw className="w-4 h-4" /> */}
              Change Status
            </button>
            <button
              className="flex items-center gap-2 py-2 px-4 bg-blue-500 text-white rounded-md hover:bg-blue-600"
              onClick={(e) => {
                e.preventDefault();
                handleUpdate(bookingData.id);
              }}
            >
              {/* <Edit className="w-4 h-4" /> */}
              Edit
            </button>
            <button
              onClick={onClose}
              className="flex items-center gap-2 py-2 px-4 bg-gray-500 text-white rounded-md hover:bg-gray-600"
            >
              {/* <X className="w-4 h-4" /> */}
              Close
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Modal;
